﻿import React from 'react';
import PropTypes from 'prop-types';
import { Popover, Position, Intent } from "@blueprintjs/core";
import { Button } from 'components/buttons'

export function ButtonList(
    {
        id = null,
        intent = "",
        disabled = false,
        icon = null,
        iconOnly = false,
        text = "",
        minimal = false,
        large = true,
        popoverClassName = null,
        menuItems
    }
) {

    let intentValue = Intent.NONE;
    if (intent) {
        switch (intent.toLowerCase()) {
            case "save":
            case "info":
            case "primary":
                intentValue = Intent.PRIMARY;
                break;
            case "warning":
                intentValue = Intent.WARNING;
                break;
            case "danger":
            case "delete":
                intentValue = Intent.DANGER;
                break;
            default:
                intentValue = Intent.NONE
        }
    }

    return (
        <Popover content={menuItems} position={Position.BOTTOM} popoverClassName={popoverClassName}>
            <Button id={id} disabled={disabled} icon={icon} iconOnly={iconOnly} text={text} intent={intentValue} minimal={minimal} large={large} onClick={() => { }} />
        </Popover>
    );
}

ButtonList.propTypes = {
    id: PropTypes.string,
    intent: PropTypes.string,
    disabled: PropTypes.bool,
    icon: PropTypes.string,
    iconOnly: PropTypes.bool,
    text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    minimal: PropTypes.bool,
    large: PropTypes.bool,
    popoverClassName: PropTypes.string
};